import { z } from 'zod';
import { objectIdSchema } from './objectId';

export const TimeSchema = z.object({
  hour: z.number(),
  minute: z.number(),
});

export const TimeFormat = ['12', '24'] as const;

export const TimeBlockSchema = z.object({
  name: z.string(),
  index: z.number(),
});

export const DayType = ['sea', 'port'] as const;

export const DaySchema = z.object({
  _id: objectIdSchema,
  name: z.string(),
  type: z.enum(DayType),
  title: z.string(),
});

export const TimeStringFormat = ['compact', 'locale', 'xcompact'] as const;
